import Cookie from "js-cookie";

export default {
  set: Cookie.set
};
